import { useContext, useState } from "react";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import primaryComponents from "../../../../primaryComponents";
import { RequestLoader } from "../../../../../hooks/context";
import { getRandomIntInclusive } from "../../../../../helpers";
import secondaryComponents from "../../..";
import { useValidateWalletSession } from "../../../../../hooks/api/mutations/useInventory";

const StoreWalletOtpWidget = ({ sessionId = "", callBackFunc = () => {} }) => {
  const [otp, setOtp] = useState("");
  const { setRequestLoaderProgress } = useContext(RequestLoader);

  const { mutate, isLoading } = useValidateWalletSession();
  const handleOtpInput = (value) => {
    setOtp(value);
    if (value?.length !== 6) return;
    setRequestLoaderProgress(getRandomIntInclusive(10, 30));

    mutate(
      {
        otp_code: value,
        session_id: sessionId,
      },
      {
        onSuccess: () => {
          callBackFunc(value);
        },
        onSettled: () => {
          setRequestLoaderProgress(100);
        },
      },
    );
  };

  return (
    <div className={`p-3 text-center ${globalStyles.pageColumnGaps}`}>
      <div>
        <h5 className="purple--text">Store Wallet Verification</h5>
        <p>Enter the 6-digit code sent to your email and phone number</p>
      </div>

      <secondaryComponents.LoaderHelper
        isLoading={isLoading}
        classNames={"mt-3"}
      >
        <div className="mx-auto" style={{ width: "300px" }}>
          <primaryComponents.OtpInputField
            onChange={handleOtpInput}
            numOfInputs={6}
            value={otp}
          />
        </div>
      </secondaryComponents.LoaderHelper>
    </div>
  );
};
export default StoreWalletOtpWidget;
